import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `length` property of an object.
export default shallowProperty('length');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_getLength.js
// module id = 7
// module chunks = 3